module.exports = __webpack_public_path__ + "img/undraw_my_location.c60cc571.svg";